import { initializeApp, getApps, type FirebaseApp } from "firebase/app";
import {
  getMessaging,
  getToken,
  onMessage,
  type Messaging,
} from "firebase/messaging";

let app: FirebaseApp | null = null;
let messaging: Messaging | null = null;

const env = import.meta.env as any;

export function initFirebase() {
  if (!env.VITE_FIREBASE_API_KEY) {
    return;
  }

  if (getApps().length === 0) {
    app = initializeApp({
      apiKey: env.VITE_FIREBASE_API_KEY,
      authDomain: env.VITE_FIREBASE_AUTH_DOMAIN,
      projectId: env.VITE_FIREBASE_PROJECT_ID,
      storageBucket: env.VITE_FIREBASE_STORAGE_BUCKET,
      messagingSenderId: env.VITE_FIREBASE_MESSAGING_SENDER_ID,
      appId: env.VITE_FIREBASE_APP_ID,
      measurementId: env.VITE_FIREBASE_MEASUREMENT_ID,
    });
  } else {
    app = getApps()[0];
  }

  messaging = getMessaging(app);

  // Send the Firebase config to the service worker so it can initialize
  // Firebase Messaging in the background.
  if ("serviceWorker" in navigator) {
    const reg = navigator.serviceWorker.controller;
    if (reg) {
      reg.postMessage({
        type: "FIREBASE_CONFIG",
        config: {
          apiKey: env.VITE_FIREBASE_API_KEY,
          authDomain: env.VITE_FIREBASE_AUTH_DOMAIN,
          projectId: env.VITE_FIREBASE_PROJECT_ID,
          storageBucket: env.VITE_FIREBASE_STORAGE_BUCKET,
          messagingSenderId: env.VITE_FIREBASE_MESSAGING_SENDER_ID,
          appId: env.VITE_FIREBASE_APP_ID,
          measurementId: env.VITE_FIREBASE_MEASUREMENT_ID,
        },
      });
    }
  }

  return messaging;
}

export { getMessaging, getToken, onMessage };
export { app, messaging };
